// Imports
import React from "react";

// Hooks
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

// Controls
import { Tabs, TabContainer, Container } from "@gpstrackit/gtc-react-controls";

// Tabs
import TrackerTab from '../trackerTab'
import CustomerTab from '../customerTab'
import ScheduleTab from '../schedule'

import { setTab } from './redux/slice'

import './index.scss'

const WorkOrdersMainView = () => {
  const { messages } = useIntl();

  const tab = useSelector((state) => state.workOrdersMainRedux.tab);

  const dispatch = useDispatch();

  const tabs = [
    {
      id: "tracker",
      label: messages['workOrder_main_tracker'],
      component: <TrackerTab />,
    },
    {
      label: messages['workOrder_main_schedule'],
      master: "workorders",
      subUser: [289],
      component: <ScheduleTab />,
    },
    {
      id: "customers",
      label: messages['workOrder_main_customers'],
      component: <CustomerTab />,
    }
  ];

  return (
    <Container maxWidth={false} className="container-view">
      <div className="work-orders-main">
        <Tabs tab={tab} onChange={(value) => dispatch(setTab(value))}>
          {tabs.map((item, index) => {
            const { id, label, component } = item;
            return (
              <TabContainer key={id} label={label} index={index}>
                {component}
              </TabContainer>
            );
          })}
        </Tabs>
      </div>
    </Container>
  );
};

export default WorkOrdersMainView;